import { createContext } from 'react';
import { ModalState } from '../ModalState';

export interface ModalContextType {
  openModal: (modal: ModalState) => void;
  closeModal: () => void;
}

export const ModalContext = createContext<ModalContextType | null>(null);
